/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SupplementalResponseHeaderStyle {
    NumberBySupplementalResponseDocumentCount = 'NumberBySupplementalResponseDocumentCount',
    NumberBySupplementalInterrogatoryResponseCount = 'NumberBySupplementalInterrogatoryResponseCount'
}

export function SupplementalResponseHeaderStyleFromJSON(json: any): SupplementalResponseHeaderStyle {
    return SupplementalResponseHeaderStyleFromJSONTyped(json, false);
}

export function SupplementalResponseHeaderStyleFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalResponseHeaderStyle {
    return json as SupplementalResponseHeaderStyle;
}

export function SupplementalResponseHeaderStyleToJSON(value?: SupplementalResponseHeaderStyle | null): any {
    return value as any;
}